import { render } from "./JsonView.vue?vue&type=template&id=2c6a1e43&scoped=true"
import script from "./JsonView.vue?vue&type=script&lang=js"
export * from "./JsonView.vue?vue&type=script&lang=js"

import "./JsonView.vue?vue&type=style&index=0&id=2c6a1e43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6a1e43"]])

export default __exports__